import { defineRecipe } from '@chakra-ui/react';

export const textareaRecipe = defineRecipe({
  base: {
    resize: 'vertical',
    minH: '80px',
    maxH: '300px',
    width: 'full',
    borderColor: 'grey.light.2',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: 'bg',
    color: 'grey.dark.1',
    padding: '0.5rem 0.5rem',
    rounded: 'smaller',
    fontSize: '0.875rem', // 14px
    minWidth: '48px',

    outline: 'none',

    transitionDuration: 'faster',
    transitionTimingFunction: 'linear',
    transitionProperty: 'border-color',

    _active: {
      borderColor: 'grey.light.3',
    },

    _focus: {
      borderColor: 'grey.light.3',
    },

    _disabled: {
      cursor: 'not-allowed',
      backgroundColor: 'grey.light.0',
    },
  },
  variants: {},
  defaultVariants: {},
});
